export const travelPassEnvConfig = {
  dev: {
    dreamFolksBaseUrl: "https://staging.info.dreamfolks.in/outlet-list",
  },
  uat: {
    dreamFolksBaseUrl: "https://staging.info.dreamfolks.in/outlet-list",
  },
  prod: {
    dreamFolksBaseUrl: "https://info.dreamfolks.in/outlet-list",
  },
};
